import { BirthDateVerificationProps } from './models';
import { css } from 'styled-components';

export const BirthDateVerification = css<BirthDateVerificationProps>(({ theme }) => {
  return css`
    border-radius: 0;
    width: 100%;
    overflow: auto;

    > .dialog-title {
      font-size: 21px;
      font-weight: 700;
    }

    > .buttons-row {
      padding: 0;
      margin: 25px 0;
      > .blue-btn {
        margin: 0;
        width: 246px;
      }
    }

    > .popup-content {
      text-align: center;
      > .sub-title {
        font-size: 14px;
        font-weight: 400;
      }

      > .date-of-birth-input-container {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        height: 450px;

        > .field {
          display: flex;
          justify-content: center;
          > .date-of-birth-picker {
            width: 231px;
            > div {
              align-items: center;
              > .flatpickr-calendar {
                margin-top: 14px;
                &::before,
                &::after {
                  border-bottom-color: transparent;
                }
              }
            }
          }
        }
      }
    }

    @media screen and ${theme.device.mobileXL} {
      border-radius: 16px;
      width: 800px;
      > .dialog-title {
        font-weight: 600;
        font-size: 25px;
        line-height: 36px;
      }
      > .buttons-row > .blue-btn {
        width: 335px;
      }
      > .popup-content {
        > .sub-title {
          font-size: 16px;
          line-height: 21px;
          font-weight: 500;
        }

        > .date-of-birth-input-container {
          margin-top: 24px;
          display: flex;
          justify-content: center;
          height: 450px;

          > .field {
            display: flex;
            justify-content: center;
            > .date-of-birth-picker {
              > div {
                > .flatpickr-calendar {
                  margin-top: 24px;
                }
              }
            }
          }
        }
      }
    }
  `;
});
